import { useEffect, useState } from 'react';
import { Box, Input } from '@/ui';

type Props = {
  value: string;
  // Shown when the view has no header title of its own — the owning planner's
  // title, which is what the header renders until the author types one here.
  placeholder?: string;
  onSave: (value: string) => void;
};

export const TitleInput = ({ value, placeholder, onSave }: Props) => {
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  return (
    <Box
      bg="white"
      border="1px solid"
      borderColor="line.DEFAULT"
      borderRadius="ah-xl"
      mb={2}
      overflow="hidden"
    >
      <Input
        _focus={{ borderColor: 'transparent', boxShadow: 'none' }}
        _placeholder={{ color: 'ink.muted' }}
        border="none"
        color="ink.strong"
        fontSize="ah-control"
        fontWeight={500}
        outline="none"
        placeholder={placeholder}
        px={3}
        py={2.5}
        value={localValue}
        // Only an actual edit writes: tabbing through the field must not clear a
        // seeded title (which shows here as empty) or otherwise touch the view.
        onBlur={() => localValue !== value && onSave(localValue)}
        onChange={(e) => setLocalValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.currentTarget.blur();
          }
        }}
      />
    </Box>
  );
};
